import request from '@/utils/request'

export const login = params => request.post('/masterdata-api/login', params)
